<template>
  <div class="home">
    <!-- 会员开通提示横幅 -->
    <div v-if="!isVipUser" class="vip-promotion-banner">
      <div class="banner-content">
        <div class="banner-left">
          <i class="fas fa-crown banner-icon"></i>
          <div class="banner-text">
            <h3>开通会员，享受更多特权</h3>
            <p>海量高清图片下载，不限数量，专享会员资源</p>
          </div>
        </div>
        <div class="banner-right">
          <router-link to="/membership" class="vip-btn">
            <span>立即开通</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Element UI 轮播图 -->
    <header class="hero">
      <el-carousel 
        :interval="5000" 
        :arrow="posters.length > 1 ? 'hover' : 'never'"
        height="450px"
        class="hero-carousel"
      >
        <el-carousel-item 
          v-for="(poster, index) in posters" 
          :key="index"
          class="carousel-item"
        >
          <div 
            class="carousel-slide"
            :style="{ backgroundImage: `url('${poster.posterUrl}')` }"
          >
            <!-- 可以在这里添加轮播图上的内容 -->
            <!-- <div class="hero-content">
              <h1>令人惊叹的免费图片</h1>
              <div class="search-box">
                <input
                  type="text"
                  v-model="searchQuery"
                  placeholder="搜索图片..."
                  @keyup.enter="handleSearch"
                >
                <button @click="handleSearch">搜索</button>
              </div>
              <p class="sub-text">超过 2,700,000 张高质量图片素材</p>
            </div> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </header>

    <div class="image-sections">
      <!-- AI创作平台推广区域 -->
      <section class="ai-promotion-section" @click="$router.push('/ai-creation')">
        <div class="ai-promo-content">
          <div class="ai-promo-text">
            <h2>AI 创作平台</h2>
            <p>输入提示词，让 AI 为你生成独一无二的创意图片</p>
            <span class="ai-promo-btn">立即体验 <i class="fas fa-magic"></i></span>
          </div>
          <div class="ai-promo-visual">
            <i class="fas fa-robot"></i>
          </div>
        </div>
      </section>

      <section class="recommended-section">
        <div class="section-header">
          <span class="section-title">推荐图片</span>
          <router-link to="/photos" class="view-all">
            <span class="text-anim">查看全部</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>
        <div class="image-grid">
          <div v-for="image in recommendImages" :key="image.imageId" class="image-card" @click="viewPhotoDetail(image.imageId)">
            <div class="image-wrapper" >
              <img :src="image.imageUrl" :alt="image.imageName">
              <div class="photo-actions">
                <button
                  class="favorite-btn"
                  :class="{ 'is-favorited': isFavorited(image.imageId) }"
                  @click.prevent="toggleFavorite(image.imageId)"
                >
                  <i class="fas" :class="isFavorited(image.imageId) ? 'fa-heart' : 'fa-regular fa-heart'"></i>
                </button>
              </div>
            </div>
            <div class="image-info">
              <h3>{{ image.imageName }}</h3>
              <div class="image-meta">
                <span><i class="fas fa-eye"></i> {{ image.viewCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="latest-section">
        <div class="section-header">
          <span class="section-title">最新上传</span>
          <router-link to="/photos" class="view-all">
            <span class="text-anim">查看全部</span>
            <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>
        <div class="image-grid">
          <div v-for="image in latestImages" :key="image.imageId" class="image-card" @click="viewPhotoDetail(image.imageId)">
            <div class="image-wrapper" >
              <img :src="image.imageUrl" :alt="image.imageName">
              <div class="photo-actions">
                <button
                  class="favorite-btn"
                  :class="{ 'is-favorited': isFavorited(image.imageId) }"
                  @click.prevent="toggleFavorite(image.imageId)"
                >
                  <i class="fas" :class="isFavorited(image.imageId) ? 'fa-heart' : 'fa-regular fa-heart'"></i>
                </button>
              </div>
            </div>
            <div class="image-info">
              <h3>{{ image.imageName }}</h3>
              <div class="image-meta">
                <span><i class="fas fa-eye"></i> {{ image.viewCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { favoritesMixin } from '@/mixins/favoritesMixin'
import { request } from '@/utils/request'

export default {
  name: 'HomeView',
  mixins: [favoritesMixin],
  data() {
    return {
      searchQuery: '',
      recommendImages: [],
      latestImages: [],
      isVipUser: false,
      posters: [{ posterUrl: '../assets/home.jpg' }] // 默认图片数组
    }
  },
  async created() {
    await this.fetchHomeData()
    this.loadFavorites()
    this.checkVipStatus()
    await this.fetchHomePoster()
  },
  methods: {
    handleSearch() {
      if (!this.searchQuery.trim()) return
      this.$router.push({
        path: '/photos',
        query: { keyword: this.searchQuery.trim() }
      })
    },
    async fetchHomeData() {
      try {
        const response = await fetch('/api/image/home?limit=8')
        const data = await response.json()

        this.recommendImages = data.data.recommend
        this.latestImages = data.data.latest
      } catch (error) {
        console.error('获取首页数据失败:', error)
      }
    },
    viewPhotoDetail(id) {
      // this.$router.push(`/photos/${id}`)
      window.open(`/#/photos/${id}`, '_blank')
    },
    async checkVipStatus() {
      const token = localStorage.getItem('token')
      if (!token) {
        this.isVipUser = false
        return
      }
      
      try {
        const response = await request('/api/auth/self')
        if (response.ok && response.data) {
          this.isVipUser = response.data.vipType > 0
        }
      } catch (error) {
        console.error('检查会员状态失败:', error)
        this.isVipUser = false
      }
    },
    async fetchHomePoster() {
      try {
        const response = await fetch('/api/poster/home')
        const data = await response.json()
        
        // 检查是否成功获取到数据且数组不为空
        if (data.ok && data.data && Array.isArray(data.data) && data.data.length > 0) {
          this.posters = data.data
        }
        // 注意：如果没有数据，保持默认图片
      } catch (error) {
        console.error('获取首页海报失败:', error)
        // 接口调用失败时，保持默认背景图
      }
    }
    
    // 移除了自定义轮播的相关方法，因为Element UI Carousel会自动处理
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
}

.hero {
  height: 450px;
  position: relative;
}

/* Element UI 轮播图样式 */
.hero-carousel {
  height: 100%;
}

.carousel-item {
  height: 100%;
}

.carousel-slide {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 如果需要在轮播图上添加内容 */
.hero-content {
  text-align: center;
  color: white;
  z-index: 2;
  max-width: 800px;
  padding: 0 20px;
}

.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.search-box {
  display: flex;
  max-width: 600px;
  margin: 0 auto 20px;
}

.search-box input {
  flex: 1;
  padding: 12px 20px;
  font-size: 16px;
  border: none;
  border-radius: 4px 0 0 4px;
}

.search-box button {
  padding: 12px 30px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}

.hero-content p {
  font-size: 1.1em;
  opacity: 0.9;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}

/* 自定义 Element UI 轮播图指示器样式 */
.hero-carousel ::v-deep .el-carousel__indicators {
  bottom: 20px;
}

.hero-carousel ::v-deep .el-carousel__indicator {
  width: 12px;
  height: 12px;
}

.hero-carousel ::v-deep .el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
}

.hero-carousel ::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  background-color: white;
}

/* 自定义箭头样式 */
.hero-carousel ::v-deep .el-carousel__arrow {
  background-color: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  backdrop-filter: blur(10px);
}

.hero-carousel ::v-deep .el-carousel__arrow:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-carousel ::v-deep .el-carousel__arrow {
    width: 40px;
    height: 40px;
  }
  
  .hero-carousel ::v-deep .el-carousel__button {
    width: 10px;
    height: 10px;
  }
  
  .hero-content h1 {
    font-size: 2em;
  }
}

.image-sections {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.recommended-section,
.latest-section {
  margin-bottom: 40px;
}

.recommended-section h2,
.latest-section h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.image-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
  width: 100%;
  aspect-ratio: 4/3;
}

.image-card:hover {
  transform: translateY(-5px);
}

.image-wrapper {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  min-height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.image-wrapper:hover img {
  transform: translate(-50%, -50%) scale(1.05);
}

.photo-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.photo-item:hover .photo-actions {
  opacity: 1;
}

.favorite-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.3s ease;
}

.favorite-btn:hover {
  background: white;
  color: #f44336;
}

.favorite-btn.is-favorited {
  color: #f44336;
}

.favorite-btn i {
  font-size: 18px;
}

.image-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(transparent, rgba(0,0,0,0.7));
  color: white;
  cursor: pointer;
}

.image-info h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.image-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  opacity: 0.9;
}

.image-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 768px) {
  .image-sections {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

.ai-promotion-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  margin-bottom: 40px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 15px rgba(118, 75, 162, 0.3);
  transition: transform 0.3s, box-shadow 0.3s;
}

.ai-promotion-section:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(118, 75, 162, 0.4);
}

.ai-promo-content {
  padding: 30px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.ai-promo-text h2 {
  font-size: 28px;
  margin: 0 0 10px 0;
  font-weight: 700;
}

.ai-promo-text p {
  font-size: 16px;
  opacity: 0.9;
  margin: 0 0 20px 0;
}

.ai-promo-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: white;
  color: #764ba2;
  padding: 10px 24px;
  border-radius: 20px;
  font-weight: 600;
  transition: background 0.2s;
}

.ai-promo-btn:hover {
  background: #f0f0f0;
}

.ai-promo-visual {
  font-size: 80px;
  opacity: 0.8;
  transform: rotate(15deg);
  margin-right: 20px;
}

@media (max-width: 768px) {
  .ai-promo-content {
    padding: 20px;
  }
  
  .ai-promo-text h2 {
    font-size: 24px;
  }
  
  .ai-promo-visual {
    font-size: 60px;
  }
}

.section-header {
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
  margin-bottom: 20px;
}

.section-header .section-title {
  font-weight: bold;
  font-size: 26px;
  margin-right: 10px;
}

.view-all {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4CAF50;
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s ease;
  padding: 6px 12px;
  border-radius: 20px;
  background: rgba(76, 175, 80, 0.1);
}

/* 文字动画样式 */
.text-anim {
  display: inline-block;
  animation: pulse-text 1.5s ease-in-out infinite;
}

/* 动画关键帧 */
@keyframes pulse-text {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.view-all:hover {
  color: #2196F3;
  background: rgba(33, 150, 243, 0.1);
  transform: translateX(4px);
}

.view-all i {
  font-size: 14px;
}

/* 会员开通提示横幅样式 */
.vip-promotion-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 0;
  margin-top: 20px;
  position: relative;
  overflow: hidden;
}

.vip-promotion-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="crown" patternUnits="userSpaceOnUse" width="20" height="20"><path d="M10 5l3 6h-6z" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23crown)"/></svg>') repeat;
  pointer-events: none;
}

.banner-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.banner-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.banner-icon {
  font-size: 48px;
  color: #FFD700;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px #FFD700, 0 0 20px #FFD700, 0 0 30px #FFD700;
  }
  to {
    text-shadow: 0 0 20px #FFD700, 0 0 30px #FFD700, 0 0 40px #FFD700;
  }
}

.banner-text h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: bold;
}

.banner-text p {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}

.vip-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(45deg, #FF6B6B, #FF8E53);
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
}

.vip-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  background: linear-gradient(45deg, #FF8E53, #FF6B6B);
}

.vip-btn i {
  transition: transform 0.3s ease;
}

.vip-btn:hover i {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .banner-left {
    flex-direction: column;
    gap: 15px;
  }
  
  .banner-icon {
    font-size: 36px;
  }
  
  .banner-text h3 {
    font-size: 20px;
  }
  
  .banner-text p {
    font-size: 14px;
  }
}
</style>
